import React from 'react';
import {Route, Switch, Redirect } from 'react-router-dom';
import RouteWithLayout from './components/routewithlayout/RouteWithLayout';
//import { RouteWithLayout } from './components';
//import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';


import RouteLinks from './RouteLinks'


const Routes = () => {
      
       return (
             
              <Switch>
                <Redirect
                    exact
                    from="/"
                    to="/covid19/country"
                  />
                    {RouteLinks.map((page, i) => {
                      return (
                        <RouteWithLayout
                          exact
                          layout={page.layout}
                          path={page.pageLink}
                          component={page.view}
                          displayName={page.displayName}
                          key={i}
                        />
                      );
                    })}
              
              </Switch>
    )
}

export default Routes

